// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2opEb","rootSuccess":"CompleteLink_rootSuccess__3ZEyc","rootFailure":"CompleteLink_rootFailure__3rS4n","isDisabled":"CompleteLink_isDisabled__3Y_SI"};